<template>
  <div>
    <b-modal id="serviceConfiguration" title="Service Hands-on-fees" size="xl">

      <template #modal-header>
        <div class="d-flex w-100 justify-content-left h2 text-primary">
          Service Hands-on-fees
        </div>
      </template>

      <div class="d-flex flex-column w-100">

        <div class="form-group">
          <label class="form-label">Outlet</label>
          <multiselect
            v-model="selectedOutlet"
            label="text"
            track-by="id"
            :options="outlets"
            :searchable="false"
            :show-labels="false"
            openDirection="below">
            <template slot="option" slot-scope="{ option }">{{ option.text }}</template>
          </multiselect>
        </div>

        <div class="panel-container">

          <div class="panel-content">

            <ul class="nav nav-tabs" role="tablist">
              <li class="nav-item" v-for="c of sections" :key="'section' + c.sectionID">
                <a :class="{ 'active': selectedSection['sectionID'] === c.sectionID }" class="nav-link" role="tab" @click="filterBySection(c)">
                  {{ c.name }}
                </a>
              </li>
            </ul>

            <table class="table">
              <tr>
                <th rowspan="2">Service</th>
                <th colspan="2">Free</th>
                <th colspan="2">Price</th>
              </tr>
              <tr>
                <th>Tier 1 Junior</th>
                <th>Tier 2 Senior</th>
                <th>Tier 1 Junior</th>
                <th>Tier 2 Senior</th>
              </tr>
              <tr v-for="(service, index) in selectedServices" :key="'service_' + index">
                <td>
                  <label class="form-label">{{ service['name'] }}</label>
                </td>
                <td style="min-width: 80px">
                  <input
                    class="form-control"
                    v-model="freeJunior[service['id']]"
                    type="number"
                    :searchable="false"
                    :show-labels="false" />
                </td>
                <td style="min-width: 80px">
                  <input
                    class="form-control"
                    v-model="freeSenior[service['id']]"
                    type="number"
                    :searchable="false"
                    :show-labels="false" />
                </td>
                <td style="min-width: 80px">
                  <input
                    class="form-control"
                    v-model="commJunior[service['id']]"
                    type="number"
                    :searchable="false"
                    :show-labels="false" />
                </td>
                <td style="min-width: 250px">
                  <div style="display: flex" v-for="(item, index) of commSenior[service['id']]" :key="'senior' + index">
                    <input
                      class="form-control"
                      style="width: 80px"
                      v-model="item['min']"
                      type="number"
                      :searchable="false"
                      :show-labels="false"
                      @change="onSeniorChange(service['id'], true)" />
                    <span style="margin-top: 10px">&nbsp;-&nbsp;</span>
                    <input
                      class="form-control"
                      style="width: 80px"
                      v-model="item['max']"
                      type="number"
                      readonly
                      disabled
                      :searchable="false"
                      :show-labels="false" />
                    &nbsp;&nbsp;&nbsp;
                    <input
                      class="form-control"
                      style="width: 80px"
                      v-model="item['comm']"
                      type="number"
                      :searchable="false"
                      :show-labels="false" />
                    <button type="button" class="btn btn-danger" @click="onSeniorRemove(service['id'], index)">x</button>
                  </div>
                  <button type="button" class="btn btn-primary" @click="onSeniorAdd(service['id'])">+</button>
                </td>
              </tr>
            </table>

          </div>

        </div>
      </div>

      <template #modal-footer="{ close }">
        <div class="d-flex w-100 justify-content-end">
          <b-button @click="close()" class="mr-1">Cancel</b-button>
          <b-button variant="primary" @click="save()">OK</b-button>
        </div>
      </template>

    </b-modal>

  </div>
</template>
<script>
import moment from 'moment'
import { calculateSalesReportTotal, getSubTotal } from '@/assets/js/dashboard/salonReport/salonReport.js'
import { getOutletName, handleSessionExpired } from '@/assets/js/dashboard/dashboard.js'
import { formatPrice, insertLeadingZero } from '@/assets/js/dashboard/utilities.js'
export default {
  name: "serviceConfiguration",
  data() {
    return {
      showLoading: false,
      outlets: [],
      sections: [],
      selectedSection: {},
      services: [],
      selectedServices: [],

      selectedOutlet: {},

      freeJunior: {},
      freeSenior: {},
      commJunior: {},
      commSenior: {},
    }
  },
  watch: {
    selectedOutlet(val) {
      this.onOutletChange()
    }
  },
  methods: {
    open() {
      this.$bvModal.show('serviceConfiguration')
      this.loadSection()
    },

    onOutletChange() {
      this.effort = {}
      this.loadCommission()
    },

    filterBySection(val) {
      this.selectedSection = val
      this.selectedServices.splice(0, this.selectedServices.length)

      for (let service of this.services) {        
        if (service['section']['sectionID'] === 0) {
          service['section']['sectionID'] = this.sections[0]['sectionID']
        }
        if (service['section']['sectionID'] === this.selectedSection['sectionID']) {
          this.selectedServices.push({ id: service['skuID'], name: service['name'] })
        }
      }
    },

    loadSection() {
      this.showLoading = true

      this.$axios({
        method: 'get',
        url: 'https://menu.tunai.io/business/sections?typeID=1',
        headers: { token: this.$util.getSessionToken() }
      })
        .then((response) => {
          this.showLoading = false
          this.sections = response.data.sections
          this.selectedSection = this.sections[0]

          this.loadService()
        })
        .catch((err) => {
          this.showLoading = false

          var errData = err.response.data;
          if (errData.error == this.$api.INVALID_TOKEN) {
            handleSessionExpired();
          }
        })
    },
    loadService() {
      this.showLoading = true

      this.$axios({
        method: 'get',
        url: 'https://menu.tunai.io/business/sku?typeID=1&enable=1',
        headers: { token: this.$util.getSessionToken() }
      })
        .then((response) => {
          this.showLoading = false
          this.services = response.data.skus
          this.filterBySection(this.selectedSection)
          this.onOutletChange()
        })
        .catch((err) => {
          this.showLoading = false

          var errData = err.response.data;
          if (errData.error == this.$api.INVALID_TOKEN) {
            handleSessionExpired();
          }
        })
    },
    loadCommission() {
      for(let service of this.services) {
        this.freeJunior[service['skuID']] = ''
        this.freeSenior[service['skuID']] = ''
        this.commJunior[service['skuID']] = ''
        this.commSenior[service['skuID']] = [{ min: '', max: '', comm: '' }]
      }
      
      this.showLoading = true

      let url = `https://emerchant.tunai.io/setting2.php/${this.selectedOutlet.text}_zenth_fixedCommission_service_setting`
      if (window.location.href.includes('localhost') || window.location.href.includes('127.0.0.1')) {
        url = `http://localhost:8080/setting2.php/${this.selectedOutlet.text}_zenth_fixedCommission_service_setting`
      }

      this.$axios({
        method: 'get',
        url: url,
        // headers: { token: this.$util.getSessionToken() }
      })
        .then((response) => {
          this.showLoading = false
          for (let temp in response.data) {
            let setting = (response.data[temp] || {})
            this.freeJunior[temp] = setting['freeJunior'] || ''
            this.freeSenior[temp] = setting['freeSenior'] || ''
            this.commJunior[temp] = setting['commJunior'] || ''
            this.commSenior[temp] = setting['commSenior'] || [{ min: '', max: '', comm: '' }]
            
            // this.commSenior[temp] = this.commSenior[temp].length == 0 ? [{}] : this.commSenior[temp]

            this.onSeniorChange(temp)
          }

          this.$forceUpdate()
        })
        .catch((err) => {
          this.showLoading = false

          var errData = err.response.data;
          if (errData.error == this.$api.INVALID_TOKEN) {
            handleSessionExpired();
          }
        })
    },

    save() {
      this.showLoading = true

      let request = {}
      for (let service of this.services) {
        request[service['skuID']] = {
          freeJunior: this.freeJunior[service['skuID']],
          freeSenior: this.freeSenior[service['skuID']],
          commJunior: this.commJunior[service['skuID']],
          commSenior: this.commSenior[service['skuID']],
        }
      }

      let url = `https://emerchant.tunai.io/setting2.php/${this.selectedOutlet.text}_zenth_fixedCommission_service_setting`
      if (window.location.href.includes('localhost') || window.location.href.includes('127.0.0.1')) {
        url = `http://localhost:8080/setting2.php/${this.selectedOutlet.text}_zenth_fixedCommission_service_setting`
      }

      this.$axios({
        method: 'post',
        url: url,
        // headers: { token: this.$util.getSessionToken() }
        data: request,
      })
        .then((response) => {
          this.showLoading = false

          this.$bvModal.hide('serviceConfiguration')
          this.$emit('modalClose');
        })
        .catch((err) => {
          this.showLoading = false

          var errData = err.response.data;
          if (errData.error == this.$api.INVALID_TOKEN) {
            handleSessionExpired();
          }
        })
    },

    onSeniorRemove(serviceId, index) {
      this.commSenior[serviceId].splice(index, 1)
      this.onSeniorChange(serviceId)
      this.$forceUpdate()
    },
    onSeniorAdd(serviceId) {
      this.commSenior[serviceId] = this.commSenior[serviceId] || []
      this.commSenior[serviceId].push({ min: '', max: '', comm: '' })
      this.$forceUpdate()
    },
    onSeniorChange(serviceId, forceUpdate) {
      for (let i = 0; i < this.commSenior[serviceId].length; i++) {
        let min = parseFloat(this.commSenior[serviceId][i]['min'])
        if(i > 0 && !isNaN(min)) {
          this.commSenior[serviceId][i - 1]['max'] = min - 0.01
        }
      }

      if(forceUpdate) {
        this.$forceUpdate()
      }
    },
  },
  mounted() {
    this.outlets = JSON.parse(this.$store.state.outlets)
    this.selectedOutlet = this.outlets[0]
  }
}
</script>
<style scoped>
.modal-content {
  background: transparent;
  box-shadow: none;
}

.month-picker-input-container {
  width: 100%;
}
</style>